import React from 'react';

import type { CampaignStage } from '@/services/ws-digital/src/main/resources/rest-api';
import { getStages } from '@/services/ws-orders/src/main/resources/rest-api';
import { useSubscribe } from '@/js/libs/observable';
import { useRequest } from '@/js/libs/use-request';

import { DEFAULT_DEBOUNCE_DELAY } from 'src/constants';
import type { Option } from 'src/types';

type UseStagesOptionsReturn = {
  options: Option<CampaignStage>[];
  pending: boolean;
};

type UseStagesOptions = () => UseStagesOptionsReturn;

export const useStagesOptions: UseStagesOptions = () => {
  const getStagesRequest = useRequest({
    apiMethod: getStages,
    debounce: DEFAULT_DEBOUNCE_DELAY,
  });

  const options = useSubscribe(
    getStagesRequest.data$,
    (response) =>
      response?.data.map((value) => ({
        label: value,
        value,
      })) ?? [],
  );
  const pending = useSubscribe(getStagesRequest.pending$);

  return React.useMemo<UseStagesOptionsReturn>(
    () => ({
      options,
      pending,
    }),
    [options, pending],
  );
};
